import { Link } from 'react-router-dom';

export interface CrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbsProps {
  items: CrumbItem[];
}

export default function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-2 text-xs md:text-sm text-foreground-500">
      {items.map((item, index) => (
        <span key={item.label} className="flex items-center gap-2">
          {index > 0 && <i className="ri-arrow-right-s-line text-foreground-400"></i>}
          {item.to ? (
            <Link to={item.to} className="cursor-pointer hover:text-primary-700 transition-colors">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}